import { Tooltip, Typography } from 'antd';
import moment from 'moment';
import React, { FC, useState } from 'react';
import DisplayValueIfExist from '@tools/ui/components/common/DisplayValueIfExist';
import useInterval from '@tools/ui-hooks/useInterval.hook';

type IProps = {
  date: string;
  style?: React.CSSProperties;
  format?: string;
};

const { Text } = Typography;
const DEFAULT_FORMAT = 'DD MMM YYYY HH:mm:ss';

const DateSnippet: FC<React.PropsWithChildren<IProps>> = ({
  date,
  style,
  format = DEFAULT_FORMAT
}) => {
  const [fromNow, setFromNow] = useState(
    date ? moment.utc(date).fromNow() : undefined
  );

  useInterval(() => {
    setFromNow(moment.utc(date).fromNow());
  }, 60_000);

  const dateAsString = date ? moment.utc(date).format(format) : '';

  return (
    <DisplayValueIfExist value={dateAsString}>
      <Tooltip placement="top" title={fromNow}>
        <Text style={{ ...style }}>{dateAsString}</Text>
      </Tooltip>
    </DisplayValueIfExist>
  );
};

export default DateSnippet;
